<div class="rk-ui-notification" *ngIf="successalert">
  <span id="notificationMessageText">{{successMessage}}</span>
  <a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>
<div class="rk-ui-notification err" *ngIf="erroralert">
  <span id="notificationMessageText">{{errorMessage}}</span>
  <a class="close rk-linknotification" (click)="erroralert=false">×</a>
</div>

<div class="bg-white">
  <div class="row px-4 bg-white ml-1 pb-4" >
    <app-shared-menu [lead_id]='lead_id' [lead_details]='lead_details' [lead_status]='lead_status'
      [basic_info_tab]='"active"' style="width: 100%; overflow: hidden;"></app-shared-menu>
    <div class="row m-0 mt-4 content" style="width: 100%;">
      <div class="col-12 m-2 br_calender mt-4 p-4">
        <app-sms-call></app-sms-call>
        <div class="row content mb-lg-5">

          <div class="col-md-6">
            <div class="form-group" *ngIf="lead_details">
              <label for="exampleFormControlInput1" class="ss-form-label">Lead Name</label>
              <input type="email" class="form-control ss-form-control" id="exampleFormControlInput1" value="{{lead_details.name}}" readonly>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group" *ngIf="lead_details">
              <label for="exampleFormControlInput1" class="ss-form-label">Project Name</label>
              <input type="email" class="form-control ss-form-control" id="exampleFormControlInput1" value="{{lead_details.project_details.name}}" readonly>
            </div>
          </div>

          <div class="col-md-6" *ngIf="!(role=='designer')">
            <div class="form-group d-flex flex-column" *ngIf="lead_details">
              <label for="exampleFormControlInput1" class="ss-form-label">Contact</label>
              <input type="email" class="ss-form-control" id="exampleFormControlInput1" value="{{lead_details.contact}}" readonly>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group" *ngIf="lead_details">
              <label for="exampleFormControlInput1" class="ss-form-label">Email</label>
              <input type="email" class="form-control ss-form-control" id="exampleFormControlInput1" value="{{lead_details.email}}" readonly>
              <span  *ngIf="!is_before_email_verify && (emailverified || bu_head_approved_email)" class="verification   d-flex" title="Email  verified">
                &nbsp;
                  <img src="../../../../assets/img/verified.svg" alt="">
              </span>
              <span  *ngIf="!is_before_email_verify && !(emailverified || bu_head_approved_email)"  class="verification  d-flex" title="Email not verified"> &nbsp;
                <img src="../../../../assets/img/SealWarning.svg" alt="">
              </span>
              
            </div>
          </div>

          <div class="col-md-6 mb-3 d-flex justify-content-between" *ngIf="!(role=='designer')">
            <div class="form-group d-flex gap-10 m-0 h-100 flex-column" *ngIf="lead_details">
              <p class="pt-1 switchLabelTxt mb-2">Contact visible to designer</p>
              
              <label class="switch" (click) = "changeContactStatus();">
                <input type="checkbox" id="toggleSwitch" [checked]="contact_visibel == true">
                <span class="slider"></span>
              </label>
              
            </div>
          </div>
          <div class="col-6 d-flex flex-column " style="text-align: right;">
            <div class="">
              <a *ngIf="!is_before_email_verify  && !emailverified && !bu_head_approved_email"  data-target="#confirmverification" data-toggle="modal"  class="send_mail" >Send Verificaton Email</a>
            </div>
            <div class="mt-2" *ngIf="(role=='business_head' || role=='city_gm' || role =='deputy_general_manager' ) && !is_before_email_verify && !is_proposal_shared && !emailverified && !bu_head_approved_email  " >
              <button class="btn btn-pink btns" style="height: fit-content;" (click)="markverified()"> Mark As Verified</button>
            </div>
          </div>

          <div class="col-md-6" *ngIf="role=='designer' && contact_visibel == true">
            <div class="form-group" *ngIf="lead_details">
              <label for="exampleFormControlInput1" class="ss-form-label">Contact</label>
              <div class="d-flex">
                <input type="email" class="form-control ss-form-control w-100" id="exampleFormControlInput1" value="{{lead_details.contact}}" readonly>
              </div>
            </div>
          </div>

          <div class="col-12">
              <div class="col-12 form-group pl-0" *ngIf="customerDetails">
                <div *ngFor="let user of customerDetails; let i = index; " [attr.data-index]="i">
                  <div *ngIf="user.relation != 'Customer'">
                    <span class="col-12 pl-0 font-weight-bold d-block">
                    Alternate Number {{i+1}}
                    </span>
                    <div class="col-4 d-inline-block form-group pl-0">
                        <label class="ss-form-label">Name</label>
                        <input type="text" class="form-control ss-form-control" value="{{user.name}}" readonly>
                    </div>
                    <div class="col-4 d-inline-block form-group pl-0">
                        <label class="ss-form-label">Relation</label>
                        <input type="text" class="form-control ss-form-control" value="{{user.relation}}" readonly>
                    </div>
                    <div *ngIf="!(role=='designer')" class="col-4 d-inline-block form-group pl-0">
                        <label class="ss-form-label">Contact</label>
                        <input type="text" class="form-control ss-form-control" value="{{user.contact}}" readonly>
                    </div>
                  </div>
                </div>
              </div>
          </div>
          
          <div class="col-md-4">
            <br>
            <button  class="btn btn-pink px-5 py-3 btns" data-toggle="modal" data-target="#basicDetailsModal">Click to Update</button>
          </div>

        </div>
      </div>
    </div>
  </div>

</div>

<div class="modal fade leadDetailsPopup" id="basicDetailsModal" tabindex="-1" role="dialog" aria-labelledby="SmsModalTitle" aria-hidden="true">
  <div class="modal-dialog modal-sm mobModal " role="document" style="max-width:26rem;">
    <form [formGroup]="basicDetailsForm">
      <div class="modal-content">
        <div class="modal-header d-flex justify-content-end pb-0 pt-3">
          <button  aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span  aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body mx-3">
          <div class="col-12 mb-3">
            <h5 class="text-center leadDetailsTitle">Lead Details</h5>
          </div>
          <div class="row">
            <div class="col-12 mb-3">
              <label class="filterHeading">Lead Name<span class="text-danger">*</span> </label>
              <input type="text" class="form-control mb-2" placeholder="lead name" formControlName = "name">  
            </div>

            <div class="col-12 mb-3">
              <label class="filterHeading">Email<span class="text-danger">*</span> </label>
              <input type="email" class="form-control mb-2" placeholder="lead email" formControlName = "email" [readonly]="(role != 'business_head' && role != 'city_gm'  && role != 'deputy_general_manager' && is_proposal_shared )" >
              <div>
                <span  *ngIf="!is_before_email_verify && (emailverified || bu_head_approved_email)" class="verification   d-flex" title="Email  verified">
                  &nbsp;
                    <img src="../../../../assets/img/verified.svg" alt="">
                </span>
                <span  *ngIf="!is_before_email_verify && !(emailverified || bu_head_approved_email)"  class="verification  d-flex" title="Email not verified"> &nbsp;
                  <img src="../../../../assets/img/SealWarning.svg" alt="">
                </span>
              </div>
              
              <div *ngIf="basicDetailsForm.controls['email'].invalid " class=" text-danger fs_14 pl-1"> Invalid Email</div>
            </div>

            <div class="col-12 mb-3" *ngIf="!(role=='designer')">
              <label class="filterHeading">Contact<span class="text-danger">*</span></label>
              <input type="number" class="form-control mb-2" placeholder="lead contact" oninput="javascript: if (this.value.length > 10) this.value = this.value.slice(0, 10);" formControlName="contact" maxlength=10 minlength=10>
              <div *ngIf="basicDetailsForm.controls['contact'].invalid" class="d-flex justify-content-end text-danger fs_14 pl-1"> Invalid Mobile Number</div>
            </div>
          </div>

          <div class="col-12 mb-4 pb-2 mt-3 d-flex align-items-center justify-content-center">
            <input type="button" id="lost-button" value="Update" class="btnUpdate addCursor" (click) = "updateBasicInfo()" [disabled]="!basicDetailsForm.valid">
          </div>
        
        </div>
        
      </div>
    </form>
  </div>
</div>

<div class="modal fade emailVerificationPopup" id="confirmverification" tabindex="-1" role="dialog" aria-labelledby="SmsModalTitle" aria-hidden="true">
  <div class="modal-dialog  mobModal" role="document" style="max-width:30rem;">
    <div class="modal-content">
        <div class="modal-header">
          <button  aria-label="Close" class="close pb_24" data-dismiss="modal" type="button">
            <span  aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <h5 class="emailVerificationPopupTitle">Email Verification Confirmation</h5>
          <h6 class="emailVerificationPopupDescription px-5 mx-2 mb-3">Would you like us to proceed with sending an email confirmation to customer?</h6>
          
          <div class="d-flex align-items-center justify-content-center gap-10 flex-column mt-2 mb-3 ">
            <button class="btnProceed addCursor px-4" (click)="gotoverification(lead_id)">Proceed</button>
            <button class="btnCancel addCursor" (click)="closeconfirmation()">Cancel</button>
          </div>

        </div>
      </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/platform/lead/basic-info/basic-info.component.html